const cards = [
  {
    title: 'Renegocie sua dívida com a Recovery',
    taxText: 'de desconto à vista',
    buttonText: 'Renegocie agora',
    description:
      'Identificamos uma dívida em seu nome e a Recovery é especialista em te ajudar a renegociar ela (seja com bancos, lojas, entre outros), para você conseguir as melhores condições e voltar a ter crédito no mercado',
    productCode: 'recovery_debts',
    buttonAriaLabel: 'renegocie agora',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Melhore sua aprovação de crédito'
      },
      {
        icon: {
          filename: 'consorcio'
        },
        text: 'Escolha a dívida que quer negociar'
      }
    ],
    secondOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Melhore sua aprovação de crédito'
      }
    ]
  },
  {
    title: 'Crédito com garantia de imóvel',
    buttonText: 'Continuar',
    productCode: 'cgi',
    buttonAriaLabel: 'continuar',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Até 20 anos para pagar'
      },
      {
        icon: {
          filename: 'email-resposta-rapida'
        },
        text: 'Pagamento via débito automático'
      },
      {
        icon: {
          filename: 'consorcio'
        },
        text: 'Receba em uma conta Itaú'
      }
    ],
    secondOfferHighlights: [
      {
        icon: {
          filename: 'consorcio'
        },
        text: 'Receba em uma conta Itaú'
      }
    ]
  },
  {
    title: 'Antecipação do Saque aniversário FGTS',
    buttonText: 'Seguir para contratação',
    productCode: 'FGTS',
    buttonAriaLabel: 'continuar',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'conta-corrente'
        },
        text: 'Disponível até para pessoas negativadas'
      },
      {
        icon: {
          filename: 'cobranca'
        },
        text: 'Sem prestações mensais. O desconto é direto no FGTS'
      },
      {
        icon: {
          filename: 'consorcio'
        },
        text: 'Receba em até 24h'
      }
    ],
    secondOfferHighlights: [
      {
        icon: {
          filename: 'conta-corrente'
        },
        text: 'Receba em qualquer banco. Não precisa ter uma conta Itaú',
        component: 'card_offer_hero_highlights_list'
      }
    ]
  },
  {
    title: 'Antecipação do Saque aniversário FGTS',
    buttonText: 'Finalizar no app Itaú',
    productCode: 'fgts_app',
    buttonAriaLabel: 'Continuar',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'cobranca'
        },
        text: 'Sem prestações mensais. O desconto é direto no FGTS'
      },
      {
        icon: {
          filename: 'consorcio'
        },
        text: 'Receba em até 24h'
      },
      {
        icon: {
          filename: 'beneficios'
        },
        text: 'Disponível até para negativados'
      }
    ],
    secondOfferHighlights: [
      {
        icon: {
          filename: 'consorcio'
        },
        text: 'Receba em até 24h'
      }
    ]
  },
  {
    title: 'Empréstimo consignado Itaú',
    buttonText: 'Seguir para contratação',
    loanLabel: 'Valor do empréstimo',
    productCode: 'consig_ncor',
    buttonAriaLabel: 'Seguir para contratação',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Receba o dinheiro no mesmo dia'
      },
      {
        icon: {
          filename: 'consorcio'
        },
        text: 'Receba o dinheiro em qualquer banco'
      }
    ],
    secondOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Receba o dinheiro no mesmo dia'
      }
    ]
  },
  {
    productCode: 'default',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'consorcio'
        },
        text: 'texto'
      }
    ],
    secondOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'texto'
      }
    ]
  },
  {
    title: 'Financie seu veículo com o Itaú',
    buttonText: 'Continuar',
    productCode: 'vehicles',
    buttonAriaLabel: 'continuar',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Simule as melhores condições para você'
      },
      {
        icon: {
          filename: 'seguranca-da-informacao'
        },
        text: 'Especialistas prontos para tirar suas dúvidas'
      },
      {
        icon: {
          filename: 'consorcio'
        },
        text: '10% de desconto no seguro auto Porto Seguro'
      }
    ],
    secondOfferHighlights: [
      {
        icon: {
          filename: 'consorcio'
        },
        text: '10% de desconto no seguro auto Porto Seguro'
      }
    ]
  },
  {
    title: 'Renegocie sua dívida com o Itaú',
    taxText: 'descontos especiais à vista',
    buttonText: 'Renegociar dívidas',
    productCode: 'reneg_debts',
    buttonAriaLabel: 'renegociar dívidas',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Faça um acordo sem sair de casa'
      },
      {
        icon: {
          filename: 'seguranca-da-informacao'
        },
        text: 'Condições especiais e em até 72 vezes'
      },
      {
        icon: {
          filename: 'consorcio'
        },
        text: 'Nome limpo em até 5 dias'
      }
    ],
    secondOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Faça um acordo sem sair de casa'
      },
      {
        icon: {
          filename: 'seguranca-da-informacao'
        },
        text: 'Condições especiais e em até 72 vezes'
      }
    ]
  },
  {
    title: 'Empréstimo consignado na sua conta Itaú',
    buttonText: 'Continuar',
    productCode: 'CONSIG CORR OP',
    buttonAriaLabel: 'continuar',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Até 3 meses para começar a pagar'
      },
      {
        icon: {
          filename: 'seguranca-da-informacao'
        },
        text: 'Pagamento descontado do seu sálario'
      },
      {
        icon: {
          filename: 'consorcio'
        },
        text: 'Receba o dinheiro na hora na sua conta Itaú'
      }
    ],
    secondOfferHighlights: [
      {
        icon: {
          filename: 'seguranca-da-informacao'
        },
        text: 'Pagamento descontado do seu sálario'
      }
    ]
  },
  {
    title: 'Empréstimo consignado na sua conta Itaú',
    buttonText: 'Continuar',
    productCode: 'CONSIG CORR EP',
    buttonAriaLabel: 'continuar',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Até 3 meses para começar a pagar'
      },
      {
        icon: {
          filename: 'seguranca-da-informacao'
        },
        text: 'Pagamento descontado do seu sálario'
      },
      {
        icon: {
          filename: 'consorcio'
        },
        text: 'Receba o dinheiro na hora na sua conta Itaú'
      }
    ],
    secondOfferHighlights: [
      {
        icon: {
          filename: 'seguranca-da-informacao'
        },
        text: 'Pagamento descontado do seu sálario'
      }
    ]
  },
  {
    title: 'Empréstimo consignado na sua conta Itaú',
    buttonText: 'Continuar',
    productCode: 'CONSIG CORR OP / Person',
    buttonAriaLabel: 'continuar',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Até 3 meses para começar a pagar'
      },
      {
        icon: {
          filename: 'seguranca-da-informacao'
        },
        text: 'Pagamento descontado do seu sálario'
      },
      {
        icon: {
          filename: 'consorcio'
        },
        text: 'Receba o dinheiro na hora na sua conta Itaú'
      }
    ],
    secondOfferHighlights: [
      {
        icon: {
          filename: 'seguranca-da-informacao'
        },
        text: 'Pagamento descontado do seu salário'
      }
    ]
  },
  {
    title: 'Empréstimo consignado na sua conta Itaú',
    buttonText: 'Continuar',
    productCode: 'CONSIG CORR EP / Person',
    buttonAriaLabel: 'continuar',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Até 3 meses para começar a pagar'
      },
      {
        icon: {
          filename: 'seguranca-da-informacao'
        },
        text: 'Pagamento descontado do seu salário'
      },
      {
        icon: {
          filename: 'consorcio'
        },
        text: 'Receba o dinheiro na hora na sua conta Itaú'
      }
    ],
    secondOfferHighlights: [
      {
        icon: {
          filename: 'seguranca-da-informacao'
        },
        text: 'Pagamento descontado do seu salário'
      }
    ]
  },
  {
    title: 'Refinancie seu crédito consignado Itaú',
    buttonText: 'Continuar',
    productCode: 'CONSIG CORR REFIN EP',
    buttonAriaLabel: 'continuar',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Até 3 meses para começar a pagar'
      }
    ],
    secondOfferHighlights: []
  },
  {
    title: 'Refinancie seu crédito consignado Itaú',
    buttonText: 'Continuar',
    productCode: 'CONSIG CORR REFIN OP',
    buttonAriaLabel: 'continuar',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Até 3 meses para começar a pagar'
      }
    ],
    secondOfferHighlights: []
  },
  {
    title: 'Refinancie seu crédito consignado Itaú',
    buttonText: 'Continuar',
    productCode: 'CONSIG CORR REFIN EP / Person',
    buttonAriaLabel: 'continuar',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Até 3 meses para começar a pagar'
      }
    ]
  },
  {
    title: 'Refinancie seu crédito consignado Itaú',
    buttonText: 'Continuar',
    productCode: 'CONSIG CORR REFIN OP / Person',
    buttonAriaLabel: 'continuar',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Até 3 meses para começar a pagar'
      }
    ]
  },
  {
    title: 'Refinancie seu crédito consignado Itaú',
    buttonText: 'Continuar',
    productCode: 'CONSIG CORR REFIN INSS',
    buttonAriaLabel: 'continuar',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Até 3 meses para começar a pagar'
      },
      {
        icon: {
          filename: 'seguranca-da-informacao'
        },
        text: 'Pagamento descontado do seu benefício INSS'
      },
      {
        icon: {
          filename: 'consorcio'
        },
        text: 'Receba o dinheiro na hora na sua conta Itaú'
      }
    ],
    secondOfferHighlights: [
      {
        icon: {
          filename: 'seguranca-da-informacao'
        },
        text: 'Pagamento descontado do seu benefício INSS'
      }
    ]
  },
  {
    title: 'Refinancie seu crédito consignado Itaú',
    buttonText: 'Continuar',
    productCode: 'CONSIG CORR REFIN INSS / Person',
    buttonAriaLabel: 'continuar',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Até 3 meses para começar a pagar'
      },
      {
        icon: {
          filename: 'seguranca-da-informacao'
        },
        text: 'Pagamento descontado do seu benefício INSS'
      },
      {
        icon: {
          filename: 'consorcio'
        },
        text: 'Receba o dinheiro na hora na sua conta Itaú'
      }
    ],
    secondOfferHighlights: [
      {
        icon: {
          filename: 'seguranca-da-informacao'
        },
        text: 'Pagamento descontado do seu benefício INSS'
      }
    ]
  },
  {
    title: 'Refinanciamento empréstimo consignado',
    taxText:
      'Refinancie seu \u003cspan\u003ecrédito consignado\u003c/span\u003e no Itaú e \u003cspan\u003eaproveite as vantagens\u003c/span\u003e',
    buttonText: 'Seguir para contratação',
    description: '*Proposta sujeita à análise de crédito',
    productCode: 'consig_refin_inss_ncor',
    buttonAriaLabel: 'continuar',
    heroOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Mais tempo para pagar'
      },
      {
        icon: {
          filename: 'seguranca-da-informacao'
        },
        text: 'Possibilidade de reducão de taxas de juros'
      },
      {
        icon: {
          filename: 'consorcio'
        },
        text: 'Possibilidade de liberar valor adicional na sua conta'
      }
    ],
    secondOfferHighlights: [
      {
        icon: {
          filename: 'calendario'
        },
        text: 'Mais tempo para pagar'
      },
      {
        icon: {
          filename: 'seguranca-da-informacao'
        },
        text: 'Possibilidade de reducão de taxas de juros'
      },
      {
        icon: {
          filename: 'consorcio'
        },
        text: 'Possibilidade de liberar valor adicional na sua conta'
      }
    ]
  },
  {
    title: 'Refinanciamento empréstimo consignado Itaú',
    buttonText: 'Continuar',
    productCode: 'CONSIG REFIN INSS',
    buttonAriaLabel: 'continuar'
  },
  {
    title: 'Aproveite as vantagens da conta Itaú',
    buttonText: 'Abrir conta',
    highlights: [
      {
        icon: {
          filename: 'inovacao'
        },
        text: 'Mensalidade grátis'
      },
      {
        icon: {
          filename: 'atendimento'
        },
        text: 'Canais de atendimento 24h'
      },
      {
        icon: {
          filename: 'beneficios'
        },
        text: 'Ofertas e descontos em parceiros'
      },
      {
        icon: {
          filename: 'cartao'
        },
        text: 'Cartão com débito ativo'
      }
    ],
    productCode: 'itau_account',
    subtitleBig: 'aumenta suas chances de conseguir um empréstimo',
    subtitleSmall: 'Com o Open Finance Itaú você',
    buttonAriaLabel: 'abrir conta'
  },
  {
    title: 'Peça já o seu cartão Azul Infinite',
    buttonText: 'Pedir cartão',
    highlights: [
      {
        icon: {
          filename: 'premio'
        },
        text: 'Ganhe até 60 mil pontos bônus'
      },
      {
        icon: {
          filename: 'programa-de-pontos'
        },
        text: 'Pontuação de U$$ 1 = 3,0 pontos'
      },
      {
        icon: {
          filename: 'cultura'
        },
        text: 'Acompanhante grátis em 2 viagens e 3 bagagens grátis em voos nacionais e internacionais'
      }
    ],
    productCode: 'azul_infinite_card',
    buttonAriaLabel: 'Pedir cartão'
  },
  {
    title: 'Peça já o seu cartão Azul Platinum',
    buttonText: 'Pedir cartão',
    highlights: [
      {
        icon: {
          filename: 'maiores-limites'
        },
        text: 'Limite máximo de R$ 35.000,00'
      },
      {
        icon: {
          filename: 'credito-automatico'
        },
        text: 'Anuidade grátis gastando R$ 4.000,00 por mês'
      },
      {
        icon: {
          filename: 'programa-de-pontos'
        },
        text: 'Pontuação de U$$ 1 = 2,2 pontos'
      }
    ],
    productCode: 'azul_platinum_card',
    buttonAriaLabel: 'Pedir cartão'
  },
  {
    title: 'Peça já o seu cartão Pão de Açúcar Internacional',
    buttonText: 'Pedir cartão',
    highlights: [
      {
        icon: {
          filename: 'consorcio'
        },
        text: 'Limite de até R$ 10.000,00'
      },
      {
        icon: {
          filename: 'credito-automatico'
        },
        text: 'Anuidade grátis sem gasto mínimo'
      },
      {
        icon: {
          filename: 'beneficios'
        },
        text: '20% OFF: Vinhos, Queijos, Cervejas Especiais'
      }
    ],
    productCode: 'pda_inter_card',
    buttonAriaLabel: 'pedir cartão'
  },
  {
    productCode: 'consig_comp_marg'
  }
]

export default cards
